export default function initDrawer() {
  // 管理するドロワーの定義
  const targets = [
    { toggleId: "js-search-drawer-toggle", drawerId: "js-search-drawer", label: "検索" },
    { toggleId: "js-drawer-toggle", drawerId: "js-drawer", label: "メニュー" },
  ];

  // 現在開いているドロワーを保持（排他制御用）
  let activeDrawerState = null;

  // フォーカス可能な要素を特定するセレクタ
  const focusableSelector = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"]';

  // --- 2. フォーカストラップ制御 (Tabキーのループ) ---
  // 共通で使用するためループの外に定義
  const handleKeydown = (e) => {
    // アクティブなドロワーがなければ終了
    if (!activeDrawerState) return;
    const { drawer, close } = activeDrawerState;

    // Escキーで閉じる
    if (e.key === "Escape") {
      close();
      return;
    }

    // Tabキー以外は無視
    if (e.key !== "Tab") return;

    // 現在ドロワー内に表示されているフォーカス可能な要素を取得
    const focusableEls = Array.from(drawer.querySelectorAll(focusableSelector)).filter((el) => el.offsetParent !== null);

    if (focusableEls.length === 0) return;

    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];

    if (e.shiftKey) {
      // Shift + Tab: 先頭なら末尾へ
      if (document.activeElement === firstEl) {
        e.preventDefault();
        lastEl.focus();
      }
    } else {
      // Tab: 末尾なら先頭へ
      if (document.activeElement === lastEl) {
        e.preventDefault();
        firstEl.focus();
      }
    }
  };

  // --- 3. アコーディオン制御 (HTML変更不可対応) ---
  // ドロワーごとに実行するため関数化
  const initAccordion = (drawer) => {
    // .has-child クラスを持つ親リストを取得
    const parents = drawer.querySelectorAll(".has-child");

    parents.forEach((parent) => {
      // トリガーとなる <a> タグ
      const trigger = parent.querySelector(".l-drawer-nav__link");
      // 開閉する中身
      const content = parent.querySelector(".l-drawer-nav-child");

      if (!trigger || !content) return;

      // <a>タグをボタンとして振る舞わせるためのARIA設定
      trigger.setAttribute("role", "button");
      trigger.setAttribute("aria-expanded", "false");
      trigger.setAttribute("tabindex", "0");
      // 必要であればhrefを無効化
      if (!trigger.getAttribute("href")) trigger.removeAttribute("href");

      // コンテンツの初期状態
      content.setAttribute("aria-hidden", "true");

      // クリックイベント
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        toggleAccordion(trigger, content);
      });

      // キーボード操作 (Enter / Space)
      trigger.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleAccordion(trigger, content);
        }
      });
    });
  };

  const toggleAccordion = (trigger, content) => {
    const isExpanded = trigger.getAttribute("aria-expanded") === "true";
    trigger.setAttribute("aria-expanded", !isExpanded);
    content.setAttribute("aria-hidden", isExpanded);

    // CSSフック用のクラス切り替え
    trigger.classList.toggle("is-active", !isExpanded);
    content.classList.toggle("is-open", !isExpanded);
  };

  // --- 初期化実行（各ドロワーの設定） ---
  targets.forEach((target) => {
    const toggleButton = document.getElementById(target.toggleId);
    const drawer = document.getElementById(target.drawerId);

    if (!toggleButton || !drawer) return;

    // --- 1. ドロワー開閉ロジック ---
    const toggleDrawer = (forceOpen) => {
      const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
      const nextState = typeof forceOpen === "boolean" ? forceOpen : !isExpanded;

      // 開く動作で、かつ他のドロワーが開いていたら閉じる
      if (nextState && activeDrawerState && activeDrawerState.drawer !== drawer) {
        activeDrawerState.close();
      }

      toggleButton.setAttribute("aria-expanded", nextState);
      drawer.setAttribute("aria-hidden", !nextState);
      document.body.classList.toggle("is-drawer-open", nextState);
      toggleButton.setAttribute("aria-label", nextState ? `${target.label}を閉じる` : `${target.label}を開く`);

      if (nextState) {
        // 現在のアクティブドロワーとして登録
        activeDrawerState = { drawer, toggleButton, close: () => toggleDrawer(false) };

        // 開いた時: ドロワー内の最初の要素にフォーカス移動
        setTimeout(() => {
          const firstFocusable = drawer.querySelector(focusableSelector);
          if (firstFocusable) firstFocusable.focus();
        }, 100);
        document.addEventListener("keydown", handleKeydown);
      } else {
        // 閉じた時: アクティブ情報をクリア
        if (activeDrawerState && activeDrawerState.drawer === drawer) {
          activeDrawerState = null;
        }

        document.removeEventListener("keydown", handleKeydown);
        toggleButton.focus();
      }
    };

    // ボタンイベント
    toggleButton.addEventListener("click", (e) => {
      e.preventDefault();
      toggleDrawer();
    });

    // 背景クリック等で閉じる
    // ドロワー内の閉じるボタン等にも対応
    const closeElements = drawer.querySelectorAll(".js-drawer-close");
    closeElements.forEach((el) => {
      el.addEventListener("click", () => toggleDrawer(false));
    });

    // アコーディオン初期化実行
    initAccordion(drawer);
  });
}
